import { Component, OnInit } from '@angular/core';
import { LeadsService } from '../../../../modules/leads/services/leads.service';
import { SenderService } from '../../../../services/sender.service';

@Component({
  selector: 'app-leads-scan-tasks-automessage',
  templateUrl: './leads-scan-tasks-automessage.component.html',
  styleUrls: ['./leads-scan-tasks-automessage.component.scss']
})
export class LeadsScanTasksAutomessageComponent implements OnInit {
  replayType: 'private' | 'chat' = 'private';
  constructor(
    public senderService: SenderService,
    public leadsService: LeadsService,
  ) { }

  ngOnInit(): void {
  }

  setReplayType(val: 'private' | 'chat') {

  }
}
